module.exports = __webpack_public_path__ + "static/tablet-preview-vtgym-7fd17b00eefadbd5f71fcdc4647fddbd.png";